export function DottedGrid({ children }) {
  return (
    <div
      className="h-full bg-white p-8"
      style={{
        backgroundImage: 'radial-gradient(#DDDDDD 1px, transparent 0)',
        backgroundSize: '20px 20px',
        backgroundPosition: '-19px -19px',
      }}
    >
      {children}
    </div>
  )
}
